import { on } from '@ngrx/store';
import { AsyncActions, ThemeActions } from './theme.actions';
import {asyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const themeFeatureKey = 'theme';

export interface ThemeState {
    currentTheme: string
}

export const initialState: ThemeState = {
    currentTheme: 'light-theme',
    ...asyncActionState.initial
};

const { loadActions, successActions, errorActions } = AsyncActions;

export const themeReducer = withLoadables<ThemeState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(ThemeActions.init, (state: ThemeState) => ({
        ...state,
        currentTheme: state.currentTheme
    })),

    on(ThemeActions.selectTheme, (state: ThemeState, { theme }) => ({
        ...state,
        currentTheme: theme
    }))

);
